/* eslint-disable no-unused-vars */
import React, { useCallback, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ListGroup } from 'react-bootstrap';
import _ from 'lodash';
import './styles/homescreen.css';
import homeScreenConfig from '../utils/homescreen';
import { parseQueryString, isDesktopScreen } from '../utils/utils';
import { firePageNavigationEvent } from '../utils/events';
import useTranslation from '../hooks/use-translation';
import getSource from '../utils/get-source';
import BannerIcon from "../images/BannerIcon.svg"
import * as Ms from '@microsoft/teams-js';
import { gtag } from "../utils/gtm-util";
import LinkCorporateModal from "./LinkCorporateModal";
import { _getPartnerIds, _associateJhhPartnerApiCall } from "../utils/Network/partnerOnBoarding";
import { _getItemFromLocalDecrypted } from "network-helper";
import { _getItemFromLocal, _removeItemFromLocal, _setItemInLocal } from "../utils/LocalKeys";
import { raiseGAEvent } from '../utils/network';


const getSourceId = async () => {
  const { source_id } = parseQueryString();
  if (source_id) {
    return Promise.resolve(source_id);
  }
  const sourceData = await getSource();
  return sourceData.source_id;
}

export default () => {
  const [state, setState] = useState({
    source_id: undefined
  })
  const { push } = useHistory();
  const { t } = useTranslation();
  const [showLinkModal, _setShowLinkModal] = useState(false);

  const redirectTo = useCallback(path => async () => {
    if (path.indexOf("http") > -1) {
      if (path.indexOf("avighna") > -1) {
        raiseGAEvent("AVIGHNA", "Clicked", "Avighna_hometile");
      }
      window.location = path;
    } else {
      push(path);
      firePageNavigationEvent(path);
    }
  }, [push]);

  const _closeLinkModal = () => {
    _setShowLinkModal(false);
    _removeItemFromLocal("showLinkMsgType");
  }

  useEffect(() => {
    const msgType = _getItemFromLocal("showLinkMsgType");
    if (msgType) {
      _setShowLinkModal(true);
    }

    function gtag() { window.dataLayer.push(arguments); }
    gtag('event', 'page_view', {
      page_title: 'Homepage',
      page_location: '/homepage',
      page_path: window.location.pathname,
      page_referrer: 'https://healthhub.jio.com'
    })

    getSourceId()
      .then(source_id => {
        setState(prevState => ({
          ...prevState,
          source_id
        }));
      })
  }, [])

  const source_id = state.source_id;

  const handleDeepLink = (tabId, name) => {
    const GAObject = {
      "new_Action": t(name)
    }
    // console.log(t(name), state.source_id, source_id, tabId);
    // raiseGAEventTeams(GAObject)
    const eventAction = t(name);
    gtag(
      "Teams Signed in Dashboard",
      eventAction,
      "",
      ""
    )
    Ms.initialize()
    Ms.executeDeepLink(
      "https://teams.microsoft.com/l/entity/" + tabId
    );
  }

  const styleClassForHeader = (state.source_id && (state.source_id === 'JioHealthHub' ||
    state.source_id === 'MyJio' || state.source_id === "JhhWebApp")) ? 'paddingTopSmall' : '';

  const homepageMobile = () => (
    <div className="home-screen-view-desktop-container">
      <div className="home-screen-logo-container"><img src={BannerIcon} className="home-screen-logo" alt="corporate offers"/></div>
      <div>
        <ListGroup className="home-screen-options-container">
          {
            (
              source_id === "MS_Teams" ?
                homeScreenConfig.ril_available_options
                : source_id === "MS_Teams_Public" ?
                  homeScreenConfig.public_available_options
                  : homeScreenConfig.available_options
            ).map((item, index) => (
              <ListGroup.Item
                className={`home-screen-grid-container ${index % 2 === 0 ? 'home-screen-grid-container-no-left-margin' : 'home-screen-grid-container-no-right-margin'}`}
                key={item.name}
                // action
                onClick={(source_id === "MS_Teams" || source_id === "MS_Teams_Public") ? () => handleDeepLink(item.tabId, item.name) : redirectTo(item.navigateTo)}
              >
                <div className="home-screen-grid-main-div">
                  <div>
                    <img src={item.icon} className="home-screen-grid-icon" alt={`${item?.name}`}/>
                  </div>
                  <div className="home-screen-grid-name">
                    {t(item.name) || item.name}
                  </div>
                  <div className="home-screen-grid-description">
                    {t(item.description) || item.description}
                  </div>
                </div>
              </ListGroup.Item>
            ))
          }
        </ListGroup>
      </div>
    </div>
  );

  const renderMobile = () => {
    return homepageMobile();
  };

  const renderDesktop = () => (
    <div className="home-screen-view-desktop-container">
      <div className="home-screen-logo-container"><img src={BannerIcon} className="home-screen-logo" alt="corporate offers"/></div>
      <div>
        <ListGroup className="home-screen-options-container">
          {
            (
              source_id === "MS_Teams" ?
                homeScreenConfig.ril_available_options
                : source_id === "MS_Teams_Public" ?
                  homeScreenConfig.public_available_options
                  : homeScreenConfig.available_options
            ).map((item, index) => (
              <ListGroup.Item
                className={`home-screen-grid-container ${index % 4 === 0 ? 'home-screen-grid-container-no-left-margin' : ''} ${index % 4 === 3 ? 'home-screen-grid-container-no-right-margin' : ''} `}
                key={item.name}
                // action
                onClick={(source_id === "MS_Teams" || source_id === "MS_Teams_Public") ? () => handleDeepLink(item.tabId, item.name) : redirectTo(item.navigateTo)}
              >
                <div className="home-screen-grid-main-div">
                  <div>
                    <img src={item.icon} className="home-screen-grid-icon" alt={`${item?.name}`} />
                  </div>
                  <div className="home-screen-grid-name">
                    {t(item.name) || item.name}
                  </div>
                  <div className="home-screen-grid-description">
                    {t(item.description) || item.description}
                  </div>
                </div>
              </ListGroup.Item>
            ))
          }
        </ListGroup>
      </div>
    </div>
  );
  return (
    <>
      {showLinkModal && <LinkCorporateModal showLinkMsgType={_getItemFromLocal("showLinkMsgType")} _closeLinkModal={_closeLinkModal} />}
      {isDesktopScreen() ? renderDesktop() : renderMobile()}
    </>
  );
};
